import { render, staticRenderFns } from "./JobItemCard.vue?vue&type=template&id=02718caa"
import script from "./JobItemCard.vue?vue&type=script&lang=ts"
export * from "./JobItemCard.vue?vue&type=script&lang=ts"
import style0 from "./JobItemCard.vue?vue&type=style&index=0&id=02718caa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports